import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorAlert, successAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { deepPurple } from '@mui/material/colors';

const BatchUpdateAllPayoutRequestModal = ({ filterPayoutFrom, filterPayoutTo, fetchPayouts }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const batchUpdate = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.post(
                '/BatchUpdate/PayoutRequest/Pending',
                {
                    dateFrom: filterPayoutFrom.format('YYYY-MM-DD'),
                    dateTo: filterPayoutTo.format('YYYY-MM-DD')
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Batch Update Success.');
                fetchPayouts();
                setOpen(false);
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                variant="contained"
                sx={{
                    display: 'flex',
                    width: '150px',
                    backgroundColor: deepPurple[500],
                    marginTop: '20px',
                    marginBottom: '20px'
                }}
                onClick={() => setOpen(true)}
            >
                Batch Update
            </Button>
            <Dialog open={open} onclose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogTitle fontSize={16}>{'Batch Update All Confirmation'}</DialogTitle>
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingY: '20px'
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <DialogContent>
                        <DialogContentText>
                            {`Are you confirm to batch update all payout requests ?`}
                        </DialogContentText>
                    </DialogContent>
                )}
                <DialogActions>
                    <Button color="error" onClick={() => setOpen(false)} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="secondary" onClick={() => batchUpdate()} disabled={loading}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BatchUpdateAllPayoutRequestModal;
